// extracted by mini-css-extract-plugin
export default {"oops":"oops_oops__MrtlA","extend":"oops_extend__l8e9w","title":"oops_title__qJ886"};